import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import 'vuetify/dist/vuetify.min.css'
import vuetify from './plugins/vuetify'
import VueCookies from 'vue-cookies'
import Notifications from 'vue-notification'
import VueTheMask from 'vue-the-mask'
export const EventBus = new Vue()

Vue.use(VueTheMask)
Vue.use(VueCookies)
Vue.use(Notifications)
// set default config
Vue.$cookies.config('1d')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
